
/** 首页相关 */
import Storages from '@/utils/storages';
const state = {
  todayEnergyTimeType: 1, //今日能耗类型
  energyProportionTimeType:2 ,//建筑类型用能占比
  hourlyConsumptionType:'01', //今日逐时能耗
  refreshInTimeFlag:1,//实时刷新标识
  CarbonBol: "", // 判断是否是碳公示 默认是true
 
};

const mutations = {
  setTodayEnergyTimeType(state, type) {
    state.todayEnergyTimeType=type;
  },
  setEnergyProportionTimeType(state, type) {
    state.energyProportionTimeType=type;
  },
  setHourlyConsumptionType(state, type) {
    state.hourlyConsumptionType=type;
  },
  setRefreshInTimeFlag(state,flag){
     state.refreshInTimeFlag=flag;
    //  Storages.setLocalStorage('$refreshInTimeFlag', flag);
  },
  SET_CARBONBOL({ CarbonBol }, bol) {
      CarbonBol = bol
      sessionStorage.setItem("CarbonBol", bol)
  },
  
};
const getters = {
  getTodayEnergyTimeType (state) {
    return state.todayEnergyTimeType;
  },
  getEnergyProportionTimeType (state) {
    return state.energyProportionTimeType;
  },
  getHourlyConsumptionType (state) {
    return state.hourlyConsumptionType;
  },
  getRefreshInTimeFlag(state){
    return state.refreshInTimeFlag;//||Storages.setLocalStorage('$refreshInTimeFlag');
  }
}
const actions = {
  SYNE_SET_CARBONBOL({ commit }, bol) {
      commit("SET_CARBONBOL", bol);
  },
  
}
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
